module.exports = __webpack_public_path__ + "static/media/storyRegister1.c8397654.png";